module.exports = __webpack_public_path__ + "static/media/KaTeX_Typewriter-Regular.53dcf861.woff";